import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';
import type { DiningOption } from '@Types/toast';

type GetDiningOptionsQuery = {
  name?: string;
};

type Params = {
  restaurantGuid: string;
  query?: GetDiningOptionsQuery;
  enabled?: boolean;
};

export function useToastDiningOptions<TData = DiningOption[], TError = unknown>(
  { restaurantGuid, query, enabled = true }: Params,
  options?: Omit<
    UseQueryOptions<DiningOption[], TError, TData>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryResult = useQuery<DiningOption[], TError, TData>({
    queryKey: ['toastDiningOptions', restaurantGuid, query?.name ?? null],
    enabled: Boolean(restaurantGuid && enabled),
    queryFn: async () => {
      const res = await service.getDiningOptions(restaurantGuid, query ?? {});
      return (res ?? []) as DiningOption[];
    },
    ...(options as UseQueryOptions<DiningOption[], TError, TData>),
  });

  return queryResult;
}
